import useMediaQuery from "@mui/material/useMediaQuery";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import ViewTimelineOutlinedIcon from "@mui/icons-material/ViewTimelineOutlined";
import GridOnOutlinedIcon from "@mui/icons-material/GridOnOutlined";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import Grid from "@mui/material/Grid";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import { CmpButtonKWithIcon } from "../ToolBox/ToolBox";
import { DisableApproveFlag } from "../../../Utility/Utilitys";

// import {userBasedHideField  } from "../../Configs/index";

const GCNAV = ({ 
                GCMenuBtn=<></>,
    xRightClick=()=>{},
    xLeftClick=()=>{},
  fNew = () => {},
  xDisableNew = false,
  fSave = () => {},
  xDisableSave = false,
  sRightClick = false,
  setShowMore = () => {}, 
  sShowMore = () => {},
  fDelete = () => {},
  xDisableDelete = false,
  fApprove = () => {},
  fDraft = () => {},
  xDisableApprove = false,
  xDisableDraft = true,
  isBtnDraft = false,
  fView = () => {},
  fSummary = () => {},
  fSearch = () => {},
}) => {
  const MediaQuery = useMediaQuery("(max-width:650px)");

  return (
    <div
      style={{
        position: "fixed",
        top: 45,
        left: 2,
        width: "99%",
        backgroundColor: "white",
        zIndex: 2,
      }}
    >
      <div>
        {/* mobile Screen nav  */}
        <Grid
          container
          spacing={0}
          className="my-2 Wms-nav-md-hide"
          columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
          sx={{ alignItems: "center" }}
        >
          <Grid
            item
            xs={2.4}
            sm={1}
            md={1}
            lg={1}
            sx={{ justifyContent: "center", textAlign: "center" }}
          >
            <CmpButtonKWithIcon
              xOnClick={fNew}
              xDisabled={xDisableNew}
              xIcon={<AddBoxRoundedIcon fontSize={"small"} />}
            />
          </Grid>
          <Grid
            item
            xs={2.4}
            sm={1}
            md={1}
            lg={1}
            sx={{ justifyContent: "center", textAlign: "center" }}
          >
            <CmpButtonKWithIcon
              xOnClick={fSave}
              xDisabled={xDisableSave}
              xIcon={<SaveRoundedIcon fontSize={"small"} />}
              xcolor="success"
            />
          </Grid>

          <Grid
            item
            xs={2.4}
            sm={1}
            md={1}
            lg={1}
            sx={{ justifyContent: "center", textAlign: "center" }}
          >
            {sRightClick ? (
              <CmpButtonKWithIcon
                xOnClick={ xRightClick}
                xDisabled={false}
                xIcon={<FirstPageIcon fontSize={"small"} />}
              />
            ) : (
              <CmpButtonKWithIcon
                xOnClick={ xLeftClick}
                xDisabled={false}
                xIcon={<LastPageIcon fontSize={"small"} />}
              />
            )}
          </Grid>
          <Grid
            item
            xs={2.4}
            sm={1}
            md={1}
            lg={1}
            sx={{ justifyContent: "center", textAlign: "center" }}
          >
            <CmpButtonKWithIcon
              xOnClick={() => {
                setShowMore(!sShowMore);
              }}
              xDisabled={false}
              xIcon={
                sShowMore ? (
                  <KeyboardDoubleArrowRightIcon fontSize={"small"} />
                ) : (
                  <KeyboardDoubleArrowDownIcon fontSize={"small"} />
                )
              }
            />
          </Grid>

          <Grid
            item
            xs={2.4}
            sm={1}
            md={1}
            lg={1}
            sx={{ justifyContent: "center", textAlign: "center" }}
          >
            <CmpButtonKWithIcon
              xOnClick={()=>{
                fDelete()
              }}
              xDisabled={xDisableDelete}
              xIcon={<DeleteRoundedIcon fontSize={"small"} />}
              xcolor="error"
            />
          </Grid>
        </Grid>
        {/* <Grid
              container
              spacing={0}
              sx={{
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              }}
              className="Wms-inbound-grn-nav-md-hide "
            >
              <Grid
                item
                xs={2}
                sm={1}
                md={0.5}
                lg={0.5}
                className="xs-dontShowInMobileView"
              >
                <CmpButtonKIcon
                  xOnClick={fMove_First}
                  xDisabled={false}
                  xIcon={<FirstPageIcon fontSize={"small"} />}
                />
              </Grid>

              <Grid
                item
                xs={2}
                sm={1}
                md={0.5}
                lg={0.5}
                className="xs-dontShowInMobileView"
              >
                <CmpButtonKIcon
                  xOnClick={fMove_Previouse}
                  xDisabled={false}
                  xIcon={<ArrowBackIosIcon fontSize={"small"} />}
                />
              </Grid>

              <Grid
                item
                xs={4}
                sm={1}
                md={1}
                lg={1}
                className="xs-dontShowInMobileView"
              >
                {sNavDocValue} of {sUser_Doc_Arr.length}
              </Grid>

              <Grid
                item
                xs={2}
                sm={1}
                md={0.5}
                lg={0.5}
                className="xs-dontShowInMobileView"
              >
                <CmpButtonKIcon
                  xOnClick={fMove_Next}
                  xDisabled={false}
                  xIcon={<ArrowForwardIosIcon fontSize={"small"} />}
                />
              </Grid>
              <Grid
                item
                xs={2}
                sm={1}
                md={0.5}
                lg={0.5}
                className="xs-dontShowInMobileView"
              >
                <CmpButtonKIcon
                  xOnClick={fMove_Last}
                  xDisabled={false}
                  xIcon={<LastPageIcon fontSize={"small"} />}
                />
              </Grid>
            </Grid> */}
        {sShowMore && (
          <Grid
            container
            spacing={0}
            // sx={{ alignItems: "center", justifyContent: "space-between" }}
            // className="Pre-Next Wms-nav-md-hide"
            sx={{ alignItems: "center" }}
            className="  Wms-inbound-grn-nav-md-hide"
          >
            <Grid
              item
              xs={2.4}
              sx={{ justifyContent: "center", textAlign: "center" }}
            >
              {isBtnDraft ? (
                <CmpButtonKWithIcon
                  xOnClick={fDraft}
                  xDisabled={xDisableDraft}
                  xIcon={<CheckCircleOutlineRoundedIcon fontSize={"small"} />}
                />
              ) : (
                <CmpButtonKWithIcon
                  xOnClick={fApprove}
                  xDisabled={xDisableApprove}
                  xIcon={<CheckCircleOutlineRoundedIcon fontSize={"small"} />}
                />
              )}
            </Grid>
            <Grid
              item
              xs={2.4}
              sm={1}
              md={1}
              lg={1}
              sx={{ justifyContent: "center", textAlign: "center" }}
            >
              <CmpButtonKWithIcon
                xOnClick={fView}
                xDisabled={false}
                xIcon={<ViewTimelineOutlinedIcon fontSize={"small"} />}
              />
            </Grid>
            <Grid
              item
              xs={2.4}
              sm={12}
              md={1}
              lg={1}
              sx={{ justifyContent: "center", textAlign: "center" }}
            >
              {GCMenuBtn}
            </Grid>
            <Grid
              item
              xs={2.4}
              sm={12}
              md={1}
              lg={1}
              sx={{ justifyContent: "center", textAlign: "center" }}
            >
              <CmpButtonKWithIcon
                xOnClick={fSummary}
                xDisabled={false}
                xIcon={<GridOnOutlinedIcon fontSize={"small"} />}
              />
            </Grid>
            <Grid
              item
              xs={2.4}
              sm={1}
              md={1}
              lg={1}
              sx={{ justifyContent: "center", textAlign: "center" }}
            >
              <CmpButtonKWithIcon
                xOnClick={fSearch}
                xDisabled={false}
                xIcon={<SearchRoundedIcon fontSize={"small"} />}
              />
            </Grid>
          </Grid>
        )}
      </div>
    </div>
  );
};

export default GCNAV;
